/* eslint-disable class-methods-use-this */
import { FormState } from "../models/pageConfig"
import { Service } from "./Service"
import StoreService from "./store"

class FormFieldService extends Service {
    private static instance: FormFieldService

    private store: StoreService

    private formStates: Array<{ key: string; state: any }>

    constructor() {
        super()
        // set le nom du service
        this.name = "FormFieldService"
        // ajoute toute les methodes du service au tableau de mapping
        this.serviceMap = []
        this.store = StoreService.getInstance()
        this.formStates = []
    }

    /**
     * Récuperation de l'instance
     */
    public static getInstance(): FormFieldService {
        if (!this.instance) {
            this.instance = new FormFieldService()
        }
        return this.instance
    }

    /**
     * subscribe ajoute le state d'un form au tableau des states
     * @param name nom du form
     * @param state state du form
     */
    public async subscribe(
        name: string,
        state: (key: string, value: any) => FormState
    ): Promise<void> {
        if (name && state && typeof state === "function") {
            this.formStates.push({ key: name, state })
        }
    }

    /**
     * unsubscribe supprime le state  du tableau
     * @param formName nom du form
     */
    public async unsubscribe(formName: string): Promise<void> {
        if (formName) {
            this.formStates = this.formStates.filter((form) => {
                return form.key !== formName
            })
        }
    }

    /**
     * send retourne le callback state du form
     * @param formName nom du form
     * @param fieldName nom du field
     * @param currentValue la valeur du field
     */
    public send(
        formName: string | undefined,
        fieldName: string,
        currentValue: unknown
    ): any | undefined {
        let state: unknown
        if (formName) {
            this.formStates.forEach((formState) => {
                if (formState.key === formName) state = formState.state
            })

            if (typeof state === "function") {
                const s = state(fieldName, currentValue)
                return s
            }
        }
        return undefined
    }
}

export default FormFieldService
